import React, { useState, useRef, useEffect } from 'react';

const INITIAL_CHATS = [
  { id:1, visitor:'James Morris',   company:'Arsenal FC',      status:'Active',  unread:2, lastMsg:'Is the Premium tier available for bulk requests?', time:'2m ago',
    messages:[
      { from:'visitor', text:'Hi, I\'m James from Arsenal FC. We\'re interested in the Premium evaluation tier.', time:'10:12' },
      { from:'agent',   text:'Hi James! Great to hear from you. Yes, Premium evaluations give you detailed written reports and video analysis. Would you like me to walk you through the pricing?', time:'10:14' },
      { from:'visitor', text:'Yes please. Also, is there a discount for bulk requests?', time:'10:15' },
      { from:'visitor', text:'Is the Premium tier available for bulk requests?', time:'10:16' },
    ]
  },
  { id:2, visitor:'Unknown visitor', company:'—',              status:'Active',  unread:1, lastMsg:'How do I sign up as a scout?', time:'8m ago',
    messages:[
      { from:'visitor', text:'How do I sign up as a scout?', time:'10:10' },
    ]
  },
  { id:3, visitor:'Emma Thompson',  company:'Man City',        status:'Closed',  unread:0, lastMsg:'Thanks, that answered my question!', time:'1h ago',
    messages:[
      { from:'visitor', text:'What\'s the difference between Standard and Premium?', time:'09:00' },
      { from:'agent',   text:'Standard ($10) covers basic assessment scores. Premium ($25) includes a full written report, video analysis, and scout certification.', time:'09:02' },
      { from:'visitor', text:'Thanks, that answered my question!', time:'09:03' },
    ]
  },
];

const QUICK_REPLIES = [
  'Thanks for reaching out! How can I help you today?',
  'I\'d be happy to walk you through our pricing.',
  'Let me connect you with our sales team.',
  'Could you share more details about your requirements?',
];

export default function LiveChat({ toast }) {
  const [chats, setChats]       = useState(INITIAL_CHATS);
  const [selected, setSelected] = useState(1);
  const [message, setMessage]   = useState('');
  const [widgetEnabled, setWidgetEnabled] = useState(true);
  const msgEnd = useRef();

  const activeChat = chats.find(c=>c.id===selected);

  useEffect(()=>{ msgEnd.current?.scrollIntoView({ behavior:'smooth' }); },[selected, chats]);

  const send = () => {
    if (!message.trim()) return;
    setChats(prev=>prev.map(c=>c.id===selected?{ ...c, unread:0, lastMsg:message, time:'Just now', messages:[...c.messages,{ from:'agent', text:message, time:new Date().toLocaleTimeString('en-GB',{hour:'2-digit',minute:'2-digit'}) }] }:c));
    setMessage('');
  };

  const closeChat = id => { setChats(prev=>prev.map(c=>c.id===id?{...c,status:'Closed',unread:0}:c)); toast?.('Chat closed'); };

  const totalUnread = chats.reduce((s,c)=>s+c.unread,0);

  return (
    <div>
      <div className="stats-grid">
        <div className="stat-card"><div className="stat-label">Active chats</div><div className="stat-value" style={{ color:'var(--accent)' }}>{chats.filter(c=>c.status==='Active').length}</div><div className="stat-sub stat-up">Live now</div></div>
        <div className="stat-card"><div className="stat-label">Unread</div><div className="stat-value" style={{ color:totalUnread>0?'#ff4d4d':'var(--text-primary)' }}>{totalUnread}</div><div className="stat-sub">Messages</div></div>
        <div className="stat-card"><div className="stat-label">Closed today</div><div className="stat-value">{chats.filter(c=>c.status==='Closed').length}</div><div className="stat-sub">Resolved</div></div>
        <div className="stat-card">
          <div className="stat-label">Chat widget</div>
          <div style={{ marginTop:6 }}>
            <button className={`btn ${widgetEnabled?'btn-primary':'btn-ghost'}`} style={{ fontSize:11,padding:'4px 12px' }} onClick={()=>{ setWidgetEnabled(v=>!v); toast?.(widgetEnabled?'Chat widget disabled':'Chat widget enabled'); }}>
              {widgetEnabled?'● Live':'○ Offline'}
            </button>
          </div>
        </div>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'280px 1fr', gap:0, border:'1px solid var(--border)', borderRadius:12, overflow:'hidden', height:520 }}>
        {/* Chat list */}
        <div style={{ borderRight:'1px solid var(--border)', overflowY:'auto' }}>
          <div style={{ padding:'14px 16px', borderBottom:'1px solid var(--border)', fontSize:13, fontWeight:600, color:'var(--text-primary)' }}>All conversations</div>
          {chats.map(c=>(
            <div key={c.id} onClick={()=>{ setSelected(c.id); setChats(prev=>prev.map(x=>x.id===c.id?{...x,unread:0}:x)); }}
              style={{ padding:'12px 16px', borderBottom:'1px solid var(--border)', cursor:'pointer', background:selected===c.id?'rgba(167,244,50,0.06)':'transparent' }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:4 }}>
                <div style={{ fontWeight:600, fontSize:13, color:'var(--text-primary)' }}>{c.visitor}</div>
                <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                  {c.unread>0&&<span style={{ background:'#ff4d4d',color:'#fff',borderRadius:99,fontSize:10,fontWeight:700,padding:'1px 6px' }}>{c.unread}</span>}
                  <span style={{ fontSize:10, color:'var(--text-dim)' }}>{c.time}</span>
                </div>
              </div>
              <div style={{ fontSize:11, color:'var(--text-dim)', marginBottom:4 }}>{c.company}</div>
              <div style={{ fontSize:12, color:'var(--text-muted)', overflow:'hidden', whiteSpace:'nowrap', textOverflow:'ellipsis' }}>{c.lastMsg}</div>
              <div style={{ marginTop:6 }}><span style={{ padding:'2px 8px',borderRadius:99,fontSize:10,background:c.status==='Active'?'rgba(167,244,50,0.15)':'rgba(138,154,151,0.15)',color:c.status==='Active'?'var(--accent)':'#8a9a97' }}>{c.status}</span></div>
            </div>
          ))}
        </div>

        {/* Chat window */}
        {activeChat ? (
          <div style={{ display:'flex', flexDirection:'column' }}>
            <div style={{ padding:'12px 16px', borderBottom:'1px solid var(--border)', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
              <div>
                <div style={{ fontWeight:600, fontSize:14, color:'var(--text-primary)' }}>{activeChat.visitor}</div>
                <div style={{ fontSize:11, color:'var(--text-dim)' }}>{activeChat.company}</div>
              </div>
              {activeChat.status==='Active'&&<button className="btn btn-ghost" style={{ fontSize:11,padding:'4px 10px' }} onClick={()=>closeChat(activeChat.id)}>Close chat</button>}
            </div>

            <div style={{ flex:1, overflowY:'auto', padding:'16px', display:'flex', flexDirection:'column', gap:12 }}>
              {activeChat.messages.map((m,i)=>(
                <div key={i} style={{ display:'flex', justifyContent:m.from==='agent'?'flex-end':'flex-start' }}>
                  <div style={{ maxWidth:'70%' }}>
                    <div style={{ padding:'10px 14px', borderRadius:m.from==='agent'?'16px 16px 4px 16px':'16px 16px 16px 4px', background:m.from==='agent'?'rgba(167,244,50,0.12)':'var(--bg-input)', border:`1px solid ${m.from==='agent'?'rgba(167,244,50,0.2)':'var(--border)'}`, fontSize:13, color:'var(--text-primary)', lineHeight:1.5 }}>
                      {m.text}
                    </div>
                    <div style={{ fontSize:10, color:'var(--text-dim)', marginTop:4, textAlign:m.from==='agent'?'right':'left' }}>{m.time}</div>
                  </div>
                </div>
              ))}
              <div ref={msgEnd}/>
            </div>

            {activeChat.status==='Active' && (
              <div style={{ padding:'12px 16px', borderTop:'1px solid var(--border)' }}>
                <div style={{ display:'flex', gap:6, flexWrap:'wrap', marginBottom:8 }}>
                  {QUICK_REPLIES.map((r,i)=>(
                    <button key={i} onClick={()=>setMessage(r)} style={{ padding:'4px 10px',borderRadius:99,fontSize:11,border:'1px solid var(--border)',background:'var(--bg-input)',color:'var(--text-muted)',cursor:'pointer' }}>{r.substring(0,30)}...</button>
                  ))}
                </div>
                <div style={{ display:'flex', gap:8 }}>
                  <input className="search-input" style={{ flex:1 }} placeholder="Type a message..." value={message} onChange={e=>setMessage(e.target.value)} onKeyDown={e=>e.key==='Enter'&&send()} />
                  <button className="btn btn-primary" onClick={send}>Send</button>
                </div>
              </div>
            )}
            {activeChat.status==='Closed' && (
              <div style={{ padding:'16px', textAlign:'center', color:'var(--text-dim)', fontSize:13 }}>This conversation is closed</div>
            )}
          </div>
        ) : <div style={{ display:'flex', alignItems:'center', justifyContent:'center', color:'var(--text-dim)', fontSize:13 }}>Select a conversation</div>}
      </div>
    </div>
  );
}
